import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { TAX, TAX_ADD, TAX_DELETE } from "./actionTypes";
import {
  apiError,
  getTaxs,
  TaxListSuccessful,
  TaxAddSuccessful,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  postEdit,
  postDelete,
  // getRowData,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getTax() {
  try {
    const response = yield call(getList, "/masters/taxs/", {});
    yield put(TaxListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* AddTax({ payload: { Tax } }) {
  try {
    if (Tax.id === "") {
      const response = yield call(postAdd, "/masters/taxs/", {
        name: Tax.name,
        tax: Tax.tax,
      });
      if (response.status === 201) {
        swal("Your Tax Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getTaxs());
      } else {
        swal("Sorry! Unable to ad Tax. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(TaxAddSuccessful(null));
    } else {
      const response = yield call(postEdit, "/masters/taxs/" + Tax.id, {
        name: Tax.name,
        tax: Tax.tax,
      });
      if (response.status === 200) {
        swal("Your Tax Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getTaxs());
      } else {
        swal("Sorry! Unable to edit Location. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(TaxAddSuccessful(null));
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteTax(TaxID) {
  try {
    const response = yield call(
      postDelete,
      "/masters/taxs/" + TaxID.payload.TaxId
    );
    if (response.status === 204) {
      swal("Your Tax has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getTaxs());
    } else {
      swal("Sorry! Your Tax has been not deleted!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

export function* watchgetTax() {
  yield takeEvery(TAX, getTax);
}
export function* watchTaxAdd() {
  yield takeEvery(TAX_ADD, AddTax);
}

export function* watchTaxDelete() {
  yield takeEvery(TAX_DELETE, DeleteTax);
}

function* TaxSaga() {
  yield all([fork(watchgetTax), fork(watchTaxAdd), fork(watchTaxDelete)]);
}

export default TaxSaga;
